/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Schedule_InvalidInputs */

const vi_shop_home_schedule_invalid = /** @type {(inputs: Shop_Home_Schedule_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giờ kết thúc phải sau giờ bắt đầu.`)
};

/**

* @param {Shop_Home_Schedule_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_schedule_invalid = /** @type {((inputs?: Shop_Home_Schedule_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Schedule_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_schedule_invalid(inputs)
});